var _defs, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1622898745461,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2884,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 13.032727A510.138182 510.138182 0 0 0 90.530909 809.658182a35.141818 35.141818 0 0 0 28.858182 15.127273 33.978182 33.978182 0 0 0 20.247273-6.05091 34.676364 34.676364 0 0 0 9.309091-48.407272 438.923636 438.923636 0 0 1-75.17091-228.538182h56.785455a37.701818 37.701818 0 0 0 0-75.170909H76.334545A437.992727 437.992727 0 0 1 162.909091 256l32.581818 32.581818a37.701818 37.701818 0 0 0 53.294546-53.061818L214.109091 200.378182a439.156364 439.156364 0 0 1 263.214545-116.363637 34.443636 34.443636 0 0 0-2.094545 11.869091v59.345455a37.701818 37.701818 0 0 0 75.170909 0V96.349091a40.96 40.96 0 0 0-2.094545-11.869091A437.992727 437.992727 0 0 1 809.890909 199.214545l-36.305454 36.305455a37.701818 37.701818 0 0 0 53.294545 53.061818L861.090909 254.603636a436.596364 436.596364 0 0 1 88.203636 212.014546h-55.854545a37.701818 37.701818 0 0 0 0 75.170909h58.88a437.294545 437.294545 0 0 1-72.610909 224.814545 34.909091 34.909091 0 0 0 58.181818 38.632728A510.370909 510.370909 0 0 0 512 13.032727z",
    "p-id": 2885,
    fill: "#a6a6a6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M608.814545 377.250909L498.036364 488.727273a51.432727 51.432727 0 0 0-8.610909 0 62.370909 62.370909 0 1 0 62.370909 62.138182 46.545455 46.545455 0 0 0 0-7.912728l111.010909-111.010909a37.469091 37.469091 0 0 0-53.061818-53.061818z",
    "p-id": 2886,
    fill: "#a6a6a6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.0eedbe45e1e2f23a012d29169142f210.svg";
export { ForwardRef as ReactComponent };